module.exports = __webpack_public_path__ + "static/media/IMG_0288.c24563e8.jpg";